import getContentGraphParams from './getContentGraphParams';
import getQueryParamOverride from '@gameday/utils/getQueryParamOverride';

const CONTENT = 'content';
const CONTENT_GRAPH = 'contentGraph';

const getContentDataSource = (useContentApi = false, params) => {
    const useContentApiOverride = getQueryParamOverride('useContentApi');
    return (useContentApiOverride ?? useContentApi)
        ? {
            name: CONTENT,
            params
        }
        : {
            name: CONTENT_GRAPH,
            params: getContentGraphParams(params)
        };
};

export default getContentDataSource;
